import { Card, CardContent, CardMedia, Typography, Button } from '@mui/material';
import NorthIcon from '@mui/icons-material/North';
import { getAT, formatDay } from '../../../format-date';

export const WeatherFutureCard = ({ weather, index, showId, expanded, handleExpandClick }) => {

  return (
    <div className='weather-future_card'>
      <Card sx={{ backgroundColor: 'rgba(255, 255, 255, .4)' }} key={index} >
        <CardContent>
          <Typography variant='h5' component='div'>
            {formatDay(weather.dt_txt)}
          </Typography>
          <Typography variant='h5' component='div'>
            {(weather.dt_txt).substr(11, 5)}
          </Typography>
          <div className='weather-img'>
            <CardMedia
              component='img'
              image={`http://openweathermap.org/img/wn/${weather.weather[0].icon}@2x.png`}
              alt={weather.weather[0].main}
              sx={{ maxWidth: '100px' }}
            />
          </div>
          <Typography variant='h5' component='div'>
            {Math.ceil(weather.main.temp)} °С
          </Typography>
          <div>
            <NorthIcon sx={{ transform: `rotate(${weather.wind.deg}deg)` }} />
          </div>
          <Typography variant='body2'>
            Швидкість вітру {weather.wind.speed ? Math.ceil(weather.wind.speed) : 0} м/с
          </Typography>
          <Typography variant='body2'>
            Пориви вітру до {weather.wind.gust ? Math.ceil(weather.wind.gust) : 0} м/с
          </Typography>
          {!weather.rain && !weather.snow ?
            <Typography variant='body2'>Опади 0 мм</Typography> :
            <>
              {weather?.rain && <Typography variant='body2'>
                Опади {!!weather.rain['3h']} мм
              </Typography>}
              {weather?.snow && <Typography variant='body2'>
                Опади {!!weather.snow['3h']} мм
              </Typography>
              }
            </>
          }
          <Typography variant='body2'>
            Атмосферний тиск {weather.main.grnd_level ?
              getAT(weather.main.grnd_level) :
              weather.main.pressure ? getAT(weather.main.pressure) : 0} мм. рт. ст.
          </Typography>
          <Typography variant='body2'>
            Вологість: {weather.main.humidity ? weather.main.humidity : 0} %
          </Typography>
          <Typography variant='body2'>
            Хмарність: {weather.clouds.all ? weather.clouds.all : 0} %
          </Typography>
        </CardContent>
        <Button variant='contained'
          sx={{
            marginBottom: '10px',
            backgroundColor: '#6565f5',
            '&:hover': { backgroundColor: '#4d4de9' }
          }}
          id={index}
          onClick={(e) => handleExpandClick(weather.main.temp, weather.dt_txt, e.target.id)}>
          {(+showId === index && expanded) ? 'Сховати поради' : 'Показати поради'}
        </Button>
      </Card>
    </div>
  )
}